import { defineMessages } from 'react-intl'

export default defineMessages({
    searchHere: {
        defaultMessage: 'Buscar estaciones aquí',
    },
    cantSearchHere: {
        defaultMessage: 'Acércate para poder buscar',
    },
})
